import {
GET_PAGE,
UPDATE_PAGE,
ERROR_PAGE,
MESSAGE_PAGE,
RESET_PAGE,
SAVE_PAGE,
GET_SEO,
UPDATE_SEO
} from "../actions/types"

const initialState = {
  page: null,
  seo: null,
  error: null,
  message: null,
};

export default function themeReducer(state = initialState, action) {
  switch (action.type) {
  
  case SAVE_PAGE:
    return {...state , page: action.payload }

  case RESET_PAGE:
    return {...state , page: null }

  case GET_PAGE:
    return {...state , page: action.payload.content}
  
  case UPDATE_PAGE:
    return {...state , page: action.payload , message: 'Theme successfully updated' }

  case ERROR_PAGE:
      return {...state , error: action.payload}

  case MESSAGE_PAGE:
      return {...state , message: action.payload}

  case GET_SEO:
    return {...state , seo: action.payload}

  case UPDATE_SEO:
    return {...state , message: 'Theme successfully updated'}
      
    default:
      return {...state};
  }
}